<ng-container *transloco="let t">
<div>
  <!--begin::Header-->
  <div>
    <h3 class="align-items-start flex-column">
      <span class="text-muted mt-1 fw-bold fs-7">{{ t('wizard.creditInquiry.inquiriesCount', { count: inquiry.entries.length }) }}</span>
    </h3>
  </div>
  <!--end::Header-->
  <!--begin::Body-->
  <div>
    <!--begin::Table container-->
    <div class="table-responsive">
      <form #borrowerInfoForm="ngForm" novalidate id="borrowerInfoForm" name="borrowerInfoForm">
        <table class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
          <!--begin::Table head-->
          <thead>
            <tr class="fw-bolder text-muted">
              <th class="min-w-150px">{{ t('wizard.creditInquiry.inquirer') }}</th>
              <th class="min-w-140px">{{ t('wizard.creditInquiry.date') }}</th>
              <th class="min-w-100px text-end">{{ t('wizard.creditInquiry.reason') }}</th>
              <th class="min-w-100px text-end">{{ t('wizard.creditInquiry.newDebtAcquired') }}</th>
            </tr>
          </thead>
          <!--end::Table head-->
          <tbody>
            @for (entry of inquiry.entries; track $index; let i = $index) {
              <tr>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="d-flex justify-content-start flex-column">
                      <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">{{entry.fullName}}</a>
                      <span class="text-muted fw-bold text-muted d-block fs-7"></span>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="text-dark fw-bolder d-block fs-6">{{entry.creditInquiryDate}}</span>
                </td>
                <td class="text-end">
                  <select class="form-select form-select-solid" [(ngModel)]="entry!.reason" data-control="select2" id="reason{{borrowerIndex}}{{i}}" name="reason{{borrowerIndex}}{{i}}"
                  [ngClass]="{'is-invalid' : reason && reason.touched && reason.invalid}"  #reason="ngModel">
                    <option value="">{{ t('wizard.creditInquiry.selectOne') }}</option>
                    <option value="AutoLoan">{{ t('wizard.creditInquiry.reasonAutoLoan') }}</option>
                    <option value="CreditCard">{{ t('wizard.creditInquiry.reasonCreditCard') }}</option>
                    <option value="MortgageShopping">{{ t('wizard.creditInquiry.reasonMortgageShopping') }}</option>
                  </select>
                </td>
                <td class="text-end">
                  <select class="form-select form-select-solid" [(ngModel)]="entry!.newDebtAcquired" data-control="select2" id="newDebtAcquired{{borrowerIndex}}{{i}}" name="newDebtAcquired{{borrowerIndex}}{{i}}"
                  [ngClass]="{'is-invalid' : newDebtAcquired && newDebtAcquired.touched && newDebtAcquired.invalid}"  #newDebtAcquired="ngModel">
                    <option value="">{{ t('wizard.creditInquiry.selectOne') }}</option>
                    <option value="true">{{ t('common.yes') }}</option>
                    <option value="false">{{ t('common.no') }}</option>
                  </select>
                </td>
              </tr>
            }
          </tbody>
        </table>
        </form>
    </div>
    <!--end::Table container-->
  </div>
  <!--begin::Body-->
</div>
</ng-container>
